import { render, staticRenderFns } from "./PayLoginRemain.vue?vue&type=template&id=30da2056&scoped=true&"
import script from "./PayLoginRemain.vue?vue&type=script&lang=js&"
export * from "./PayLoginRemain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30da2056",
  null
  
)

export default component.exports